module.exports = __webpack_public_path__ + "img/top-10-cart.82d50a80.webp";